// models/Leave.js
class Leave {
  constructor(data = {}) {
    this.id = data.id || data._id || null;
    this.employeeId = data.employeeId || data.employee || null;
    this.leaveType = data.leaveType || 'Casual';
    this.startDate = data.startDate || '';
    this.endDate = data.endDate || '';
    // Backend uses 'numberOfDays', but we'll support both
    this.days = data.days || data.numberOfDays || 1;
    this.numberOfDays = data.numberOfDays || data.days || 1;
    this.reason = data.reason || '';
    this.status = data.status || 'Pending';
    this.appliedDate = data.appliedDate || data.createdAt || new Date().toISOString().split('T')[0];
    this.approvedBy = data.approvedBy || null;
    this.approvedDate = data.approvedDate || null;
    this.rejectionReason = data.rejectionReason || '';
    this.attachments = data.attachments || [];
    this.halfDay = data.halfDay || false;
    this.contactPhone = data.contactPhone || '';
    this.emergencyContact = data.emergencyContact || '';
    this.emergencyPhone = data.emergencyPhone || '';
    this.createdAt = data.createdAt || new Date().toISOString();
  }

  getStatusColor() {
    const colors = { 
      'Pending': '#f59e0b', 
      'Approved': '#10b981', 
      'Rejected': '#ef4444', 
      'Cancelled': '#6b7280' 
    };
    return colors[this.status] || '#6b7280';
  }

  getLeaveTypeColor() {
    const colors = { 
      'Casual': '#3b82f6', 
      'Sick': '#ef4444', 
      'Paid': '#10b981', 
      'Unpaid': '#6b7280', 
      'Maternity': '#ec4899', 
      'Paternity': '#8b5cf6' 
    };
    return colors[this.leaveType] || '#6b7280';
  }

  calculateDays() {
    if (!this.startDate || !this.endDate) return 0;
    
    if (this.halfDay) return 0.5;
    
    const start = new Date(this.startDate);
    const end = new Date(this.endDate);
    const diffTime = Math.abs(end - start);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
  }

  validate() {
    const errors = [];
    
    // Employee ID is optional - backend will handle it
    // if (!this.employeeId) errors.push('Employee is required');
    
    if (!this.startDate) errors.push('Start date is required');
    if (!this.endDate) errors.push('End date is required');
    if (!this.reason?.trim()) errors.push('Reason is required');
    if (this.reason?.trim() && this.reason.trim().length < 10) {
      errors.push('Reason must be at least 10 characters');
    }
    
    if (this.startDate && this.endDate) {
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);
      if (end < start) {
        errors.push('End date must be after or equal to start date');
      }
    }
    
    return { isValid: errors.length === 0, errors };
  }

  toJSON() { 
    const json = {
      leaveType: this.leaveType,
      startDate: this.startDate,
      endDate: this.endDate,
      numberOfDays: this.numberOfDays || this.days, // Use backend field name
      reason: this.reason,
      status: this.status,
      halfDay: this.halfDay
    };
    
    // Add optional fields if they exist
    if (this.id) json.id = this.id;
    if (this.employeeId) json.employee = this.employeeId; // Backend uses 'employee'
    if (this.appliedDate) json.appliedDate = this.appliedDate;
    if (this.approvedBy) json.approvedBy = this.approvedBy;
    if (this.approvedDate) json.approvedDate = this.approvedDate;
    if (this.rejectionReason) json.rejectionReason = this.rejectionReason;
    if (this.contactPhone) json.contactPhone = this.contactPhone;
    if (this.emergencyContact) json.emergencyContact = this.emergencyContact;
    if (this.emergencyPhone) json.emergencyPhone = this.emergencyPhone;
    if (this.attachments && this.attachments.length > 0) json.attachments = this.attachments;
    
    return json;
  }
  
  static fromJSON(json) { 
    return new Leave(json); 
  }
}

export default Leave;